// Theme configuration based on the Service Hub IT Solutions logo
export const theme = {
  colors: {
    primary: '#00A8E8', // Base brand (Blue)
    secondary: '#FF4444', // Hover/Accent (Red)
    dark: '#2C2C2C', // Dark text color
    light: '#FFFFFF',
    gray: {
      100: '#F8F9FA',
      200: '#E9ECEF',
      300: '#DEE2E6',
      400: '#CED4DA',
      500: '#ADB5BD',
      600: '#6C757D',
      700: '#495057',
      800: '#343A40',
      900: '#212529'
    },
    gradient: {
      primary: 'linear-gradient(135deg, #00A8E8 0%, #0077B6 100%)',
      secondary: 'linear-gradient(135deg, #FF4444 0%, #FF6B6B 100%)',
      hero: 'linear-gradient(135deg, rgba(255, 68, 68, 0.9) 0%, rgba(0, 168, 232, 0.9) 100%)'
    }
  },
  fonts: {
    primary: "'Poppins', sans-serif",
    secondary: "'Inter', sans-serif"
  },
  fontSizes: {
    xs: '0.75rem',
    sm: '0.875rem',
    base: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
    '6xl': '3.75rem'
  },
  fontWeights: {
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800
  },
  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1200px'
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
    '2xl': '3rem',
    '3xl': '4rem',
    '4xl': '6rem'
  },
  borderRadius: {
    sm: '0.25rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
    '2xl': '1.5rem',
    full: '9999px'
  },
  shadows: {
    sm: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    xl: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    '2xl': '0 25px 50px -12px rgba(0, 0, 0, 0.25)'
  },
  transitions: {
    // Smoother, natural-feel timings
    default: 'all 240ms cubic-bezier(0.22, 1, 0.36, 1)',
    fast: 'all 150ms ease-out',
    slow: 'all 400ms cubic-bezier(0.22, 1, 0.36, 1)',
    micro: 'all 120ms ease-out',
    relaxed: 'all 320ms cubic-bezier(0.22, 1, 0.36, 1)'
  }
};